"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      d: "M2.563 22.066c-.31.395-.211.992.223 1.334.434.341 1.037.299 1.348-.096l2.548-3.234c1.603.595 3.408.93 5.318.93 6.628 0 12-4.03 12-9 0-3.058-2.034-5.76-5.142-7.387l2.096-2.661c.31-.395.21-.991-.223-1.333-.434-.342-1.037-.3-1.348.095L16.953 3.8A15.407 15.407 0 0 0 12 3C5.373 3 0 7.03 0 12c0 2.95 1.892 5.567 4.814 7.209l-2.251 2.857Zm5.43-3.661c1.298.399 2.649.6 4.007.595 2.923 0 5.492-.891 7.285-2.236C21.078 15.419 22 13.714 22 12c0-1.715-.922-3.42-2.715-4.764a10.116 10.116 0 0 0-1.69-1.019l-2.53 3.212a4 4 0 0 1-4.847 6.153l-2.225 2.823Zm.712-4.136L6.07 17.614a9.95 9.95 0 0 1-1.355-.85C2.922 15.419 2 13.714 2 12c0-1.715.922-3.42 2.715-4.764C6.508 5.891 9.077 5 12 5c1.29 0 2.51.173 3.626.483l-2.191 2.782a4 4 0 0 0-4.73 6.004Zm2.806-.33A2.006 2.006 0 0 0 14 12c0-.336-.083-.652-.23-.93l-2.26 2.87.001-.001Zm.556-3.938-1.995 2.533A2.003 2.003 0 0 1 12.067 10v.001Z",
      clipRule: "evenodd"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};